import Vue from 'vue';

// 使用 Event Bus
const color1 = new Vue();

export default color1;



// WEBPACK FOOTER //
// ./src/view/framework/home/color.js